module.exports = __webpack_public_path__ + "static/media/anvil-squad5.51e6bee3.jpg";